import React from 'react';

interface FaqIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * FaqIcon – question mark in circle, used for FAQ/help.
 */
export const FaqIcon: React.FC<FaqIconProps> = ({ size = 20, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width={size}
    height={size}
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

export default FaqIcon;
